import Button from '@material-ui/core/Button';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

const stylesButton = {
	fontWeight: "bold",
	textTransform: "lowercase !important",
	backgroundColor: "#d3d3d3",
	color: "#297373"
}

const displayFlexCenter = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center"
}

const stylesSpan = {
	...displayFlexCenter,
	flexDirection: "column",
	textTransform: "capitalize",
	fontSize: "22px"
}

const stylesDiv = {
	...displayFlexCenter,
	margin: "20px 0",
	width: "100%",
	height: "55px",
	boxSizing: "border-box",
	backgroundColor: "rgba(0,0,0,.2)",
	// backgroundColor: "#373737",
	// borderTop: "4px solid #297373",
    // borderBottom: "4px solid #297373",
    boxShadow: "4px 0px 12px rgba(0,0,0,.4)",
}

const ButtonMore = ({ longName, longDefault, long, setLong }) => {

	function addLocalStorage(longValue){ 
		localStorage.setItem(longName, longValue)
	}

	function changeLong(){
		if (Number.parseInt(long) === -1) {
			setLong(longDefault)
			addLocalStorage(longDefault)
			return
		}

		setLong(-1)
		addLocalStorage(-1)
	}

	return (
		<div style={stylesDiv}>
			<Button
				variant="contained"
				style={stylesButton}
				onClick={changeLong}
			>
				{
					Number.parseInt(long) !== -1 
					? (
						<span style={stylesSpan}>
							<MdExpandMore size={28} />
						</span>
					) : (
						<span style={stylesSpan}>
							<MdExpandLess size={28} />
						</span>
					)
				}
			</Button>
		</div>
	)
}

export default ButtonMore;